(() => {
  const init = root => {
    const sections = root.matches?.('[data-product-videos]') ? [root] : root.querySelectorAll?.('[data-product-videos]') || [];

    sections.forEach(section => {
      if (section.dataset.ready === 'true') return;
      section.dataset.ready = 'true';

      const viewport = section.querySelector('[data-video-viewport]');
      const originals = [...section.querySelectorAll('[data-video-slide]')];
      const dotsWrap = section.querySelector('[data-video-dots]');
      const counter = section.querySelector('[data-video-counter]');
      if (!viewport || !originals.length) return;

      const cloneSlide = slide => {
        const clone = slide.cloneNode(true);
        clone.removeAttribute('data-video-slide');
        clone.removeAttribute('id');
        clone.removeAttribute('data-shopify-editor-block');
        clone.setAttribute('data-video-clone', '');
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('[id]').forEach(element => element.removeAttribute('id'));
        clone.querySelectorAll('video').forEach(video => {
          video.pause();
          video.preload = 'none';
        });
        clone.querySelectorAll('button,a,input,select,textarea').forEach(element => element.tabIndex = -1);
        return clone;
      };

      if (originals.length > 1) {
        const before = document.createDocumentFragment();
        const after = document.createDocumentFragment();
        originals.forEach(slide => before.appendChild(cloneSlide(slide)));
        originals.forEach(slide => after.appendChild(cloneSlide(slide)));
        originals[0].parentNode.insertBefore(before, originals[0]);
        originals[originals.length - 1].parentNode.appendChild(after);
      }

      const allSlides = () => [...section.querySelectorAll('.nat-product-videos__slide')];
      const normalize = value => (value % originals.length + originals.length) % originals.length;
      const step = () => originals[1] ? originals[1].offsetLeft - originals[0].offsetLeft : originals[0].offsetWidth;
      const base = () => originals[0].offsetLeft - (viewport.clientWidth - originals[0].offsetWidth) / 2;
      const rawIndex = () => Math.round((viewport.scrollLeft - base()) / Math.max(step(), 1));
      const currentIndex = () => normalize(rawIndex());
      let manualPause = false;
      let settleTimer;

      const update = () => {
        const center = viewport.scrollLeft + viewport.clientWidth / 2;
        let closest = null;
        let distance = Infinity;
        allSlides().forEach(slide => {
          const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
          const nextDistance = Math.abs(center - slideCenter);
          if (nextDistance < distance) { distance = nextDistance; closest = slide; }
          slide.classList.remove('is-active');
        });
        closest?.classList.add('is-active');

        allSlides().forEach(slide => {
          const video = slide.querySelector('video');
          const button = slide.querySelector('[data-video-toggle]');
          if (!video) return;
          if (slide === closest && !manualPause && !document.hidden && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
            video.play().catch(() => {});
            button?.classList.remove('is-paused');
            button?.setAttribute('aria-label', 'Pause video');
          } else {
            video.pause();
            button?.classList.add('is-paused');
            button?.setAttribute('aria-label', 'Play video');
          }
        });

        const active = currentIndex();
        [...(dotsWrap?.children || [])].forEach((dot, i) => dot.classList.toggle('is-active', i === active));
        if (counter) counter.textContent = `${String(active + 1).padStart(2, '0')} / ${String(originals.length).padStart(2, '0')}`;
      };

      const settle = target => {
        clearTimeout(settleTimer);
        if (target >= 0 && target < originals.length) return;
        settleTimer = setTimeout(() => {
          viewport.scrollTo({ left: base() + normalize(target) * step(), behavior: 'auto' });
          update();
        }, 620);
      };

      const go = target => {
        manualPause = false;
        viewport.scrollTo({ left: base() + target * step(), behavior: 'smooth' });
        settle(target);
      };

      originals.forEach((_, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = `nat-product-videos__dot${index === 0 ? ' is-active' : ''}`;
        dot.setAttribute('aria-label', `Go to video ${index + 1}`);
        dot.addEventListener('click', () => go(index));
        dotsWrap?.appendChild(dot);
      });

      let ticking = false;
      viewport.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => { update(); ticking = false; });
      }, { passive: true });

      section.querySelector('[data-video-prev]')?.addEventListener('click', () => go(rawIndex() - 1));
      section.querySelector('[data-video-next]')?.addEventListener('click', () => go(rawIndex() + 1));

      section.addEventListener('click', event => {
        const button = event.target.closest('[data-video-toggle]');
        if (!button) return;
        const slide = button.closest('.nat-product-videos__slide');
        const video = slide?.querySelector('video');
        if (!video) return;
        if (video.paused) {
          manualPause = false;
          video.play().catch(() => {});
          button.classList.remove('is-paused');
          button.setAttribute('aria-label', 'Pause video');
        } else {
          manualPause = true;
          video.pause();
          button.classList.add('is-paused');
          button.setAttribute('aria-label', 'Play video');
        }
      });

      let timer;
      const stop = () => clearInterval(timer);
      const start = () => {
        stop();
        if (section.dataset.autoplay !== 'true' || originals.length < 2 || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        timer = setInterval(() => go(rawIndex() + 1), Number(section.dataset.speed) || 7000);
      };

      section.addEventListener('mouseenter', stop);
      section.addEventListener('mouseleave', start);
      section.addEventListener('focusin', stop);
      section.addEventListener('focusout', start);
      section.addEventListener('pointerdown', stop, { passive: true });
      section.addEventListener('pointerup', () => setTimeout(start, 1000), { passive: true });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) { stop(); update(); } else { update(); start(); }
      });

      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          viewport.scrollTo({ left: base() + currentIndex() * step(), behavior: 'auto' });
          update();
        }, 150);
      });

      requestAnimationFrame(() => {
        viewport.scrollTo({ left: base(), behavior: 'auto' });
        update();
        start();
      });
    });
  };

  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
